module.exports = __webpack_public_path__ + "static/media/android.53aa5a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/android.png
// module id = 1095
// module chunks = 0